import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Callback } from './auth/callback';
import { Dashboard } from './pages/Dashboard';
import { Search } from './pages/Search';
import { RecordView } from './pages/RecordView';
import { RestorePlan } from './pages/RestorePlan';
import { RestoreApproval } from './pages/RestoreApproval';
import { RestoreExecution } from './pages/RestoreExecution';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/callback" element={<Callback />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/search" element={<Search />} />
                <Route path="/records/:objectType/:recordId" element={<RecordView />} />
                <Route path="/restore/plan" element={<RestorePlan />} />
                <Route path="/restore/approval/:planId" element={<RestoreApproval />} />
                <Route path="/restore/execution/:planId" element={<RestoreExecution />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
